import { z } from 'zod';

import {
  CoffeeDrink,
  CoffeeOrderStatus,
  CoffeeFlavour,
} from '@/lib/data/domains/coffee-console';

/**
 * The console has no form in this wave (read-only rows + search + button
 * actions), so there is no user-input schema to write here. This validates
 * the D-19 contract shape instead — a row parsed through this is guaranteed
 * to match the frozen wire format, for the mock fixtures and any future
 * runtime checks to lean on.
 */
export const CoffeeOrderConsoleRowSchema = z.object({
  id: z.string(),
  number: z.string(),
  status: z.nativeEnum(CoffeeOrderStatus),
  drink: z.nativeEnum(CoffeeDrink),
  drinkLabel: z.string(),
  flavour: z.nativeEnum(CoffeeFlavour),
  flavourLabel: z.string(),
  quantity: z.number(),
  customerName: z.string(),
  createdAt: z.number(),
  notifiedAt: z.number().optional(),
  pickedUpAt: z.number().optional(),
});
